export interface FirstStepSignupAssignment {
  user_id: string;
  week_index: number;
  column_index: number;
  slot_kind?: 'standard' | 'alternate';
  assigned_at?: string;
  assigned_by?: 'self' | 'facilitator';
  display_name?: string;
  display_short?: string;
  is_you?: boolean;
}

export interface FirstStepSignupWeek {
  week_index: number;
  presentation_date: string | null;
  locked_for_member: boolean;
}

export interface FirstStepSignupConfig {
  enabled: boolean;
  enabled_at?: string | null;
  closed_at?: string | null;
  standard_slot_count: number;
  alternate_slot_count: number;
  first_presentation_week_date: string;
  week_count: number;
  locked_week_indexes: number[];
  assignments: FirstStepSignupAssignment[];
  weeks?: FirstStepSignupWeek[];
  can_facilitate?: boolean;
}

export const EMPTY_FIRST_STEP_SIGNUP: FirstStepSignupConfig = {
  enabled: false,
  standard_slot_count: 5,
  alternate_slot_count: 1,
  first_presentation_week_date: '',
  week_count: 10,
  locked_week_indexes: [],
  assignments: [],
};
